import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import sw from './sw.json';
import fr from './fr.json';
import homeEn from './home.en.json';
import homeSw from './home.sw.json';
import homeFr from './home.fr.json';
import authEn from './auth.en.json';
import authSw from './auth.sw.json';
import authFr from './auth.fr.json';
import crmPortalEn from './crmPortal.en.json';
import crmPortalSw from './crmPortal.sw.json';
import crmPortalFr from './crmPortal.fr.json';
import digitalCardEn from './digitalCard.en.json';
import digitalCardSw from './digitalCard.sw.json';
import digitalCardFr from './digitalCard.fr.json';
import {
  normalizeUiLang,
  TCARDS_LANG_MANUAL_KEY,
  TCARDS_LANG_AUTO_KEY,
  TCARDS_LANG_STORAGE_KEY,
  clearStaleEnglishForEastAfricaBrowser,
} from '../utils/localePreference';

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: 'tcardsComposite',
  lookup() {
    clearStaleEnglishForEastAfricaBrowser();
    try {
      const manual = localStorage.getItem(TCARDS_LANG_MANUAL_KEY);
      if (manual) return normalizeUiLang(manual);
      const auto = localStorage.getItem(TCARDS_LANG_AUTO_KEY);
      if (auto) return normalizeUiLang(auto);
      const legacy = localStorage.getItem(TCARDS_LANG_STORAGE_KEY);
      if (legacy) return normalizeUiLang(legacy);
    } catch {
      /* ignore */
    }
    return undefined;
  },
  cacheUserLanguage() {
    /* Persistence handled in localeBootstrap + explicit persistManualLanguage */
  },
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: { ...en, ...homeEn, ...authEn, ...crmPortalEn, ...digitalCardEn } },
      sw: { translation: { ...sw, ...homeSw, ...authSw, ...crmPortalSw, ...digitalCardSw } },
      fr: { translation: { ...fr, ...homeFr, ...authFr, ...crmPortalFr, ...digitalCardFr } },
    },
    supportedLngs: ['en', 'sw', 'fr'],
    fallbackLng: 'en',
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    returnObjects: true,
    showSupportNotice: false,
    detection: {
      order: ['tcardsComposite'],
      caches: [],
    },
  });

export default i18n;
